/** Stable RVE IndexedDB key for an org-scoped creative. */
export function neoProjectId(orgId: number | string, creativeId: number): string {
  return `aspectly-orgs-${orgId}-creatives-${creativeId}`;
}
